/**
 * Images live on a plain CDN with no transforms, so full-size files (1.5 MB+) were
 * being downloaded for slots a few hundred pixels wide. These helpers route them
 * through a resizing image proxy that returns compressed WebP at the needed width.
 */
const PROXY = 'https://wsrv.nl/'

export const IMAGE_PROXY_ORIGIN = 'https://wsrv.nl'

export function optimizedImage(src: string, width: number, quality = 70): string {
  return `${PROXY}?url=${encodeURIComponent(src)}&w=${width}&output=webp&q=${quality}&af&il`
}

export function optimizedSrcSet(src: string, widths: number[], quality = 70): string {
  return widths.map((width) => `${optimizedImage(src, width, quality)} ${width}w`).join(', ')
}

// The hero mockup is the LCP element on mobile, so the candidate list is tuned to
// the real rendered size (≈370 CSS px at 1.75 DPR) instead of over-serving pixels.
export const HERO_WIDTHS = [320, 420, 560, 680]
export const HERO_SIZES = '(max-width: 640px) 90vw, 560px'

export const OFFER_WIDTHS = [320, 420, 560, 720]
export const OFFER_SIZES = '(max-width: 640px) 86vw, 420px'

export const BONUS_WIDTHS = [200, 280, 380]
export const BONUS_SIZES = '(max-width: 640px) 58vw, (max-width: 1024px) 28vw, 190px'
